var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("quickViewController", [
    "$rootScope",
    "$sce",
    "$scope",
    "$window",
    "$q",
    "$timeout",
    "catalogService",
    "cartService",
    "elasticService",
    "loaderService",
    "modalService",
    "productService",
    "urlService",
    "recentlyViewedService",
    function (
        $rootScope,
        $sce,
        $scope,
        $window,
        $q,
        $timeout,
        catalogService,
        cartService,
        elasticService,
        loaderService,
        modalService,
        productService,
        urlService,
        recentlyViewedService
    ) {
        //#region Fields

        //#region Catalog
        $scope.catalog = {
            productDefinition: catalogService.productDefinition,
            productType: catalogService.productType,
        };
        //#endregion

        //#region Quick View
        $scope.quickView = {
            addingToCart: false,
            isOpen: false,
            isProductInCart: false,
            isProductInStock: null,
            product: null,
            productAssociatedItems: [],
            productAssociatedItemsVariants: [],
            productId: null,
            productVariant: null,
            productVariants: [],
            inspirations: [],
            inspirationsMaster: [],
            inspirationsActiveIndex: 3,
            recommendedProducts: {
                isFetched: false,
                stabilizers: [],
                threadsObj: {
                    defaultThreads: [],
                    threadConverterSequences: [],
                    threadLength: null,
                    threadLengths: [],
                    threadMfg: null,
                    thread: null,
                    threads: [],
                    threadType: null,
                },
            },
            isCombosaleapplied: null,
            isCombosaleactive: null,
            buyAllSizes: false,
        };

        $scope.finalPrice = 0;
        //#endregion

        //#endregion

        //#region Watch

        //#region Quick View
        $scope.$watch("customerCartRS", function () {
            setRecommendedProductsCartCustomProperties();
        });

        $scope.$watch("quickView.productVariant", function () {
            if ($scope.quickView.productVariant) {
                $rootScope.$emit("RefreshCurrencyConversion");
                setProductAssociatedItems();
            }
        });

        $scope.$watchGroup(
            ["customerCartRS", "quickView.productVariant"],
            function () {
                $scope.quickView.isProductInCart = _.some(
                    $rootScope.customerCartRS || [],
                    function (productId) {
                        return (
                            productId.toLowerCase() ==
                            _.get(
                                $scope.quickView,
                                ["productVariant", "itemId"],
                                ""
                            ).toLowerCase()
                        );
                    }
                );
            }
        );
        //#endregion

        //#endregion

        //#region Events

        //#region Quick View
        $rootScope.$on("NewFavoritesGroupModalClosed", function (_event) {
            $scope.quickView.isOpen && $scope.openQuickView();
        });

        $rootScope.$on("ShowQuickView", function (_event, productId) {
            resetQuickView();
            $scope.quickView.productId = productId;
            if (typeof gtag !== "undefined" && gtag !== null) {
                gtag("event", "quick_view", {
                    product_id: productId,
                });
            }
            recentlyViewedService.updateRecentlyViewed(productId);
            initializeQuickView();
        });
        //#endregion

        //#endregion

        //#region Functions

        //#region Inspiration

        $scope.onNavClick = function (navOption) {
            switch (navOption) {
                case "quick-prev":
                    if (
                        $scope.windowWidth > 1599 &&
                        $scope.quickView.inspirationsActiveIndex - 4 > 0
                    ) {
                        $scope.quickView.inspirationsActiveIndex =
                            $scope.quickView.inspirationsActiveIndex - 1;
                        $scope.quickView.inspirations.pop();
                        $scope.quickView.inspirations.unshift(
                            $scope.quickView.inspirationsMaster[
                                $scope.quickView.inspirationsActiveIndex - 4
                            ]
                        );
                    } else if (
                        $scope.windowWidth < 1600 &&
                        $scope.quickView.inspirationsActiveIndex - 3 > 0
                    ) {
                        $scope.quickView.inspirationsActiveIndex =
                            $scope.quickView.inspirationsActiveIndex - 1;
                        $scope.quickView.inspirations.pop();
                        $scope.quickView.inspirations.unshift(
                            $scope.quickView.inspirationsMaster[
                                $scope.quickView.inspirationsActiveIndex - 3
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.quickView.inspirationsActiveIndex <
                        $scope.quickView.inspirationsMaster.length
                    ) {
                        $scope.quickView.inspirationsActiveIndex =
                            $scope.quickView.inspirationsActiveIndex + 1;
                        $scope.quickView.inspirations.splice(0, 1);
                        $scope.quickView.inspirations.push(
                            $scope.quickView.inspirationsMaster[
                                $scope.quickView.inspirationsActiveIndex - 1
                            ]
                        );
                    }
                    break;
            }
        };

        function checkInspirations() {
            $scope.quickView.inspirationsMaster = [];
            $scope.quickView.inspirations = [];
            $q.all([
                productService.getInspirationImages(
                    $scope.quickView.productId,
                    $scope.quickView.product.definitionName,
                    $scope.quickView.product.catalog
                ),
                productService.checkProductVideosExists(
                    $scope.quickView.productId,
                    $scope.quickView.product.catalog
                ),
            ]).then(function (responses) {
                if (responses && responses.length > 0) {
                    var inspirations = responses[0].data;
                    var checkVideoExists = responses[1].data;
                    var video = undefined;
                    if (
                        checkVideoExists &&
                        angular.isDefined(window.__env) &&
                        angular.isDefined(window.__env.productVideosBaseUrl)
                    ) {
                        var videoUrl = urlService.getProductVideoUrl({
                            catalogId: $scope.quickView.product.catalog,
                            sku: $scope.quickView.productId.split(/-(.+)/)[1],
                        });
                        video = {
                            id: 1,
                            videoUrl: videoUrl,
                        };
                    }

                    $scope.quickView.inspirationsMaster.push({
                        id: 0,
                        imgUrl: $scope.quickView.product.customPropImageUrl,
                    });
                    angular.forEach(inspirations, function (img, key) {
                        var imageUrl = urlService.getImageUrl({
                            definitionName:
                                $scope.quickView.product.definitionName,
                            size: "xlarge",
                            catalogId: $scope.quickView.product.catalog,
                            sku: $scope.quickView.productId.split(/-(.+)/)[1],
                        });
                        imageUrl = imageUrl.replace(
                            /.webp|.jpg|.gif/gi,
                            function () {
                                return "/" + img;
                            }
                        );
                        $scope.quickView.inspirationsMaster.push({
                            id:
                                key + 1 >= 1 && angular.isDefined(video)
                                    ? key + 2
                                    : key + 1,
                            imgUrl: imageUrl,
                        });
                    });

                    if (angular.isDefined(video)) {
                        $scope.quickView.inspirationsMaster.splice(1, 0, video);
                    }
                    $scope.getActiveInspirations();
                }
            });
        }

        $scope.getActiveInspirations = function () {
            if (
                angular.isDefined($scope.quickView.inspirationsMaster) &&
                $scope.quickView.inspirationsMaster.length > 0
            ) {
                if ($scope.windowWidth > 1599) {
                    $scope.quickView.inspirationsActiveIndex = 4;
                    $scope.quickView.inspirations = angular
                        .copy($scope.quickView.inspirationsMaster)
                        .splice(0, 4);
                } else {
                    $scope.quickView.inspirationsActiveIndex = 3;
                    $scope.quickView.inspirations = angular
                        .copy($scope.quickView.inspirationsMaster)
                        .splice(0, 3);
                }
            }
        };

        function isValDefined(val) {
            return angular.isDefined(val);
        }

        function getElm(key) {
            return document.getElementById(key);
        }

        $scope.setImgSrc = function (imgSrcId, vdoSrcId, currentActivePrd) {
            var imgElm = getElm(imgSrcId);
            var vdoElm = getElm(vdoSrcId);
            if (
                isValDefined(imgElm) &&
                imgElm != null &&
                isValDefined(vdoElm) &&
                vdoElm != null &&
                isValDefined(currentActivePrd)
            ) {
                if (
                    isValDefined(currentActivePrd.imgUrl) &&
                    currentActivePrd.imgUrl != null
                ) {
                    imgElm.src = currentActivePrd.imgUrl;
                    imgElm.style.display = "block";
                    vdoElm.style.display = "none";
                    $scope.quickViewVideo = false;
                }
                if (
                    angular.isDefined(currentActivePrd.videoUrl) &&
                    currentActivePrd.videoUrl != null
                ) {
                    vdoElm.src = currentActivePrd.videoUrl;
                    vdoElm.style.display = "block";
                    imgElm.style.display = "none";

                    $scope.quickViewVideo = true;
                }
            }
        };

        $scope.onInspirationImageClick = function (image) {
            $scope.setImgSrc("quickViewMainImg", "quickViewMainVideo", image);
        };

        //#region Cart
        $scope.addRecommendedProductToCart = function (item) {
            item.customPropAddingToCart = true;
            cartService.addLineItem(item.itemId, 1).then(
                function (response) {
                    if (_.get(response, ["data", "itemAdded"])) {
                        $rootScope.customerCartRS.push(item.itemId);
                        $rootScope.$broadcast("CustomerCartChanged");
                    } else
                        alert(
                            "Le panier a atteint la limite maximale. Veuillez procéder au paiement avant d'ajouter de nouveaux articles.."
                        );
                    item.customPropAddingToCart = false;
                },
                function () {
                    item.customPropAddingToCart = false;
                }
            );
        };

        $scope.addToCart = function (buyAllSizes) {
            $scope.quickView.addingToCart = true;
            isBuyAllSizes = angular.isDefined(buyAllSizes)
                ? buyAllSizes
                : false;
            if (!isBuyAllSizes) {
                cartService
                    .addLineItem(
                        _.get(
                            $scope.quickView,
                            ["productVariant", "variantId"],
                            1
                        ) == 1
                            ? $scope.quickView.productId
                            : $scope.quickView.productId +
                                  "_var_" +
                                  $scope.quickView.productVariant.variantId,
                        1
                    )
                    .then(
                        function (response) {
                            $scope.quickView.addingToCart = false;

                            if (
                                (response.data.displayFreeDesignAlertMsg &&
                                    response.data.displayFreeDesignAlertMsg ==
                                        true) ||
                                response.data.displayFreePdfAlertMsg == true
                            ) {
                                alert(
                                    "3 designs gratuits par semaine sans achat,\n\n6 designs gratuits par semaine avec 35 $ d'achat, ou\n\n9 designs gratuits par semaine avec 75 $ d'achat."
                                );
                            }
                            _.get(response, ["data", "itemAdded"])
                                ? $rootScope.$broadcast("CustomerCartChanged")
                                : alert(
                                      "Le panier a atteint la limite maximale. Veuillez procéder au paiement avant d'ajouter de nouveaux articles."
                                  );
                        },
                        function () {
                            $scope.quickView.addingToCart = false;
                        }
                    );
            } else {
                return cartService
                    .addAllVariantsAsLineItems(
                        _.get(
                            $scope.quickView,
                            ["productVariant", "variantId"],
                            1
                        ) == 1
                            ? $scope.quickView.productId
                            : $scope.quickView.productId +
                                  "_var_" +
                                  $scope.quickView.productVariant.variantId,
                        1
                    )
                    .then(
                        function (response) {
                            $scope.quickView.addingToCart = false;
                            if (
                                response &&
                                response.data &&
                                response.data.itemAdded
                            ) {
                                if (
                                    (response.data.displayFreeDesignAlertMsg &&
                                        response.data
                                            .displayFreeDesignAlertMsg ==
                                            true) ||
                                    response.data.displayFreePdfAlertMsg == true
                                ) {
                                    alert(
                                        "3 designs gratuits par semaine sans achat,\n\n6 designs gratuits par semaine avec 35 $ d'achat, ou\n\n9 designs gratuits par semaine avec 75 $ d'achat."
                                    );
                                }
                                _.get(response, ["data", "itemAdded"])
                                    ? $rootScope.$broadcast(
                                          "CustomerCartChanged"
                                      )
                                    : alert(
                                          "Le panier a atteint la limite maximale. Veuillez procéder au paiement avant d'ajouter de nouveaux articles."
                                      );
                            }
                        },
                        function () {
                            $scope.quickView.addingToCart = false;
                        }
                    );
            }
        };
        //#endregion

        //#region Checkout
        $scope.checkout = function () {
            $window.location.href = "/cart";
        };
        //#endregion

        //#region Quick View
        $scope.closeQuickView = function () {
            $scope.quickView.isOpen = false;
            modalService.close("quickViewModal");
        };

        $scope.openQuickView = function () {
            $scope.quickView.isOpen = true;
            modalService.open("quickViewModal");
        };

        $scope.threadLengthOnChange = function () {
            $scope.quickView.recommendedProducts.threadsObj.threads = [];

            if ($scope.quickView.recommendedProducts.threadsObj.threadLength) {
                var matchingConverterSequences = _.filter(
                    $scope.quickView.recommendedProducts.threadsObj
                        .threadConverterSequences,
                    function (item) {
                        return (
                            item.threadLength ==
                            $scope.quickView.recommendedProducts.threadsObj
                                .threadLength
                        );
                    }
                );

                elasticService
                    .getElasticData(
                        elasticService.buildProductByIdsRequest(
                            angular.toJson(
                                matchingConverterSequences[0].itemId
                                    .toLowerCase()
                                    .indexOf("_var_") == -1
                                    ? matchingConverterSequences[0].itemId.toLowerCase()
                                    : matchingConverterSequences[0].itemId
                                          .toLowerCase()
                                          .split("_var_")[0]
                            )
                        )
                    )
                    .then(function (response) {
                        $scope.quickView.recommendedProducts.threadsObj.thread =
                            _.get(response, [
                                "data",
                                "hits",
                                "hits",
                                "0",
                                "_source",
                            ]);

                        if (
                            $scope.quickView.recommendedProducts.threadsObj
                                .thread
                        ) {
                            _.forEach(
                                matchingConverterSequences,
                                function (item) {
                                    var variant = _.find(
                                        $scope.quickView.recommendedProducts
                                            .threadsObj.thread.variants,
                                        function (variant) {
                                            return (
                                                variant.itemId.toLowerCase() ==
                                                item.itemId.toLowerCase()
                                            );
                                        }
                                    );
                                    variant.customPropConverterSequence = item;
                                    $scope.quickView.recommendedProducts.threadsObj.threads.push(
                                        variant
                                    );
                                }
                            );
                            setRecommendedThreadsCustomProperties();
                            $rootScope.$emit("RefreshCurrencyConversion");
                        } else setDefaultRecommendedThreads();
                    });
            } else setDefaultRecommendedThreads();
        };

        //#region Private Functions
        function checkProductAvailability() {
            var baseLineQty = window.__env.cartbaseLineQty || 10;
            $scope.catalog.productType.physical.toLowerCase() ==
                _.get(
                    $scope.quickView.product,
                    ["productType"],
                    ""
                ).toLowerCase() &&
                productService
                    .isProductInStock($scope.quickView.product.itemId)
                    .then(function (response) {
                        $scope.qtyInHand = response.data;
                        $scope.quickView.product.isProductInStock =
                            response.data > 0;
                        $scope.quickView.product.showQty =
                            response.data < baseLineQty && response.data > 0;
                    });
        }

        function initializeQuickView() {
            if ($scope.quickView.productId) {
                loaderService.show();
                elasticService
                    .getElasticData(
                        elasticService.buildProductByIdsRequest(
                            angular.toJson($scope.quickView.productId)
                        )
                    )
                    .then(
                        function (response) {
                            loaderService.hide();
                            $scope.quickView.product = _.get(response, [
                                "data",
                                "hits",
                                "hits",
                                "0",
                                "_source",
                            ]);

                            if ($scope.quickView.product) {
                                $scope.quickView.productVariant = _.get(
                                    $scope.quickView.product,
                                    ["variants", "0"]
                                );
                                $scope.quickView.productVariants = _.get(
                                    $scope.quickView.product,
                                    ["variants"]
                                );
                                checkProductAvailability();
                                setProductCustomProperties();
                                if (
                                    $scope.quickView.productVariants.length > 1
                                ) {
                                    setComboSaleProperties();
                                }

                                checkInspirations();
                                $scope.openQuickView();
                                $rootScope.$emit("RefreshCurrencyConversion");
                                $scope.finalPrice =
                                    $scope.quickView.productVariant.listPrice;
                                if (
                                    $scope.quickView.productVariant.salePrice &&
                                    $scope.quickView.productVariant.listPrice >
                                        $scope.quickView.productVariant
                                            .salePrice
                                ) {
                                    $scope.finalPrice =
                                        $scope.quickView.productVariant.salePrice;
                                }
                                // $scope.$watch('finalPrice', function(newValue, oldValue) {
                                //     updatePaypalAmount(newValue);
                                // });
                            }
                        },
                        function () {
                            loaderService.hide();
                        }
                    );

                if (window && window.__env) {
                    $scope.showQuickViewFreebies =
                        window.__env.showQuickViewFreebies;
                }
            }
        }

        // function updatePaypalAmount(amount) {
        //     // Use $timeout to ensure that the element is available in the DOM
        //     $timeout(function() {
        //         var paypalContainer = document.getElementById('paypal-messaging-container');
        //         if (paypalContainer) {
        //             paypalContainer.setAttribute('data-pp-amount', amount);
        //         }
        //     });
        // }

        function resetQuickView() {
            $scope.quickView.addingToCart = false;
            $scope.quickView.isOpen = false;
            $scope.quickView.isProductInStock = null;
            $scope.quickView.product = null;
            $scope.quickView.productAssociatedItems = [];
            $scope.quickView.productAssociatedItemsVariants = [];
            $scope.quickView.productId = null;
            $scope.quickView.productVariant = null;
            $scope.quickView.productVariants = [];
            $scope.quickView.recommendedProducts = {
                isFetched: false,
                stabilizers: [],
                threadsObj: {
                    defaultThreads: [],
                    threadConverterSequences: [],
                    threadLength: null,
                    threadLengths: [],
                    threadMfg: null,
                    thread: null,
                    threads: [],
                    threadType: null,
                },
            };
            $scope.quickView.isCombosaleapplied = null;
            $scope.quickView.isCombosaleactive = null;
            $scope.quickView.buyAllSizes = false;
        }

        function setDefaultRecommendedThreads() {
            //Exquisite
            $scope.quickView.recommendedProducts.threadsObj.defaultThreads.push(
                {
                    imageUrl: urlService.getImageUrl({
                        catalogId: "emb store",
                        definitionName: $scope.catalog.productDefinition.thread,
                        sku: "est01-efl1500",
                    }),
                    name: "Exquisite",
                    productUrl: "threads/threadcategories?sale=exquisite",
                }
            );

            //Madeira
            $scope.quickView.recommendedProducts.threadsObj.defaultThreads.push(
                {
                    imageUrl: urlService.getImageUrl({
                        catalogId: "madeira",
                        definitionName: $scope.catalog.productDefinition.thread,
                        sku: "mp01-mpcr2700",
                    }),
                    name: "Madeira",
                    productUrl: "threads/threadcategories?sale=madeira",
                }
            );

            //Robison-Anton
            $scope.quickView.recommendedProducts.threadsObj.defaultThreads.push(
                {
                    imageUrl: urlService.getImageUrl({
                        catalogId: "ct company",
                        definitionName: $scope.catalog.productDefinition.thread,
                        sku: "cc01-rabm1100",
                    }),
                    name: "Robison-Anton",
                    productUrl: "threads/threadcategories?sale=robison",
                }
            );

            //Sulky
            $scope.quickView.recommendedProducts.threadsObj.defaultThreads.push(
                {
                    imageUrl: urlService.getImageUrl({
                        catalogId: "speedstitch",
                        definitionName: $scope.catalog.productDefinition.thread,
                        sku: "sst01-sct330",
                    }),
                    name: "Sulky",
                    productUrl: "threads/threadcategories?sale=sulky",
                }
            );
        }

        function setProductAssociatedItemCustomProperties() {
            _.forEach($scope.quickView.productAssociatedItems, function (item) {
                _.forEach(item.variants, function (variant) {
                    variant.customPropImageUrl = urlService.getImageUrl({
                        catalogId: item.catalog,
                        definitionName: item.definitionName,
                        size: "xlarge",
                        sku: variant.itemId,
                    });
                    variant.customPropIsAssociated = _.some(
                        _.compact(
                            _.get(
                                $scope.quickView.productVariant,
                                "associatedItemsList",
                                []
                            )
                        ),
                        function (itemId) {
                            return (
                                itemId.toLowerCase() ==
                                variant.itemId.toLowerCase()
                            );
                        }
                    );
                    variant.customPropItem = item;
                    variant.customPropProductUrl = urlService.getProductUrl({
                        catalogId: item.catalog,
                        definitionName: item.definitionName,
                        name: variant.variantLabel,
                        sku: variant.itemId,
                    });
                });
            });
        }

        function setProductAssociatedItems() {
            $scope.quickView.productAssociatedItems = [];
            $scope.quickView.productAssociatedItemsVariants = [];
            if (
                _.contains(
                    [
                        $scope.catalog.productDefinition.designPack.toLowerCase(),
                        $scope.catalog.productDefinition.fontPack.toLowerCase(),
                    ],
                    _.get(
                        $scope.quickView.product,
                        ["definitionName"],
                        ""
                    ).toLowerCase()
                ) &&
                !$scope.quickView.isProductInCart
            ) {
                loaderService.show();
                elasticService
                    .getElasticData(
                        elasticService.buildAssociatedItemsRequest(
                            _.uniq(
                                _.map(
                                    _.compact(
                                        _.get(
                                            $scope.quickView.productVariant,
                                            "associatedItemsList",
                                            []
                                        )
                                    ),
                                    function (itemId) {
                                        return itemId
                                            .toLowerCase()
                                            .indexOf("_var_") > -1
                                            ? itemId.split(/_var_/gi)[0]
                                            : itemId;
                                    }
                                )
                            )
                        )
                    )
                    .then(
                        function (response) {
                            loaderService.hide();
                            $scope.openQuickView();
                            $scope.quickView.productAssociatedItems = _.sortBy(
                                _.map(
                                    _.get(
                                        response,
                                        ["data", "hits", "hits"],
                                        []
                                    ),
                                    function (doc) {
                                        return _.get(doc, ["_source"]);
                                    }
                                ),
                                "name"
                            );
                            $scope.quickView.productAssociatedItemsVariants =
                                _.flatten(
                                    _.map(
                                        $scope.quickView.productAssociatedItems,
                                        function (item) {
                                            return item.variants;
                                        }
                                    )
                                );
                            setProductAssociatedItemCustomProperties();
                        },
                        function () {
                            loaderService.hide();
                            $scope.openQuickView();
                        }
                    );
            }
        }

        function setProductCustomProperties() {
            $scope.quickView.product.customPropProductUrl =
                urlService.getProductUrl({
                    catalogId: $scope.quickView.product.catalog,
                    definitionName: $scope.quickView.product.definitionName,
                    name: $scope.quickView.product.name,
                    sku: $scope.quickView.product.itemId,
                });
            $scope.quickView.product.customPropImageUrl =
                urlService.getImageUrl({
                    catalogId: $scope.quickView.product.catalog,
                    definitionName: $scope.quickView.product.definitionName,
                    size: "xlarge",
                    sku: $scope.quickView.product.itemId,
                });

            if (
                $scope.catalog.productType.physical.toLowerCase() ==
                    _.get(
                        $scope.quickView.product,
                        ["productType"],
                        ""
                    ).toLowerCase() &&
                $scope.quickView.product.mainFeatures
            )
                $scope.quickView.product.customPropMainFeaturesHtml =
                    $sce.trustAsHtml($scope.quickView.product.mainFeatures);
        }

        function setRecommendedStabilizersCustomProperties() {
            _.forEach(
                $scope.quickView.recommendedProducts.stabilizers,
                function (item) {
                    item.customPropProductUrl = urlService.getProductUrl({
                        catalogId: item.catalog,
                        definitionName: item.definitionName,
                        name: item.name,
                        sku: item.itemId,
                    });
                    item.customPropImageUrl = urlService.getImageUrl({
                        catalogId: item.catalog,
                        definitionName: item.definitionName,
                        size: "xlarge",
                        sku: item.itemId,
                    });
                }
            );
            setRecommendedProductsCartCustomProperties();
        }

        function setRecommendedThreadsCustomProperties() {
            _.forEach(
                $scope.quickView.recommendedProducts.threadsObj.threads,
                function (item) {
                    item.customPropProductUrl = urlService.getProductUrl({
                        definitionName:
                            $scope.quickView.recommendedProducts.threadsObj
                                .thread.definitionName,
                        catalogId:
                            $scope.quickView.recommendedProducts.threadsObj
                                .thread.catalog,
                        name:
                            $scope.quickView.recommendedProducts.threadsObj
                                .threadMfg +
                            " " +
                            $scope.quickView.recommendedProducts.threadsObj
                                .threadType +
                            " " +
                            item.customPropConverterSequence.colorName,
                        sku: item.itemId,
                    });

                    item.customPropImageUrl = urlService.getImageUrl({
                        catalogId:
                            $scope.quickView.recommendedProducts.threadsObj
                                .thread.catalog,
                        definitionName:
                            $scope.quickView.recommendedProducts.threadsObj
                                .thread.definitionName,
                        manufacturerPartNumber: item.manufacturerPartNumber,
                        rgb: item.rGB,
                        showThreadVariants: true,
                        sku: item.itemId,
                        threadConeImageName:
                            item.customPropConverterSequence
                                .threadConeImageName,
                    });
                }
            );
            setRecommendedProductsCartCustomProperties();
        }

        function setRecommendedProductsCartCustomProperties() {
            //Stabilizers
            _.forEach(
                $scope.quickView.recommendedProducts.stabilizers,
                function (item) {
                    item.customPropIsProductInCart = _.some(
                        $rootScope.customerCartRS || [],
                        function (productId) {
                            return (
                                productId.toLowerCase() ==
                                item.itemId.toLowerCase()
                            );
                        }
                    );
                }
            );

            //Threads
            _.forEach(
                $scope.quickView.recommendedProducts.threadsObj.threads,
                function (item) {
                    item.customPropIsProductInCart = _.some(
                        $rootScope.customerCartRS || [],
                        function (productId) {
                            return (
                                productId.toLowerCase() ==
                                item.itemId.toLowerCase()
                            );
                        }
                    );
                }
            );
        }

        function setComboSaleProperties() {
            productService
                .getComboSaleSettings(
                    $scope.quickView.product.productId,
                    $scope.quickView.product.definitionName,
                    $scope.quickView.product.catalog,
                    $scope.quickView.productVariants
                )
                .then(function (response) {
                    $scope.quickView.product.isCombosaleactive = Boolean(
                        response && response.data.isComboSaleActive
                    );
                    $scope.quickView.product.isCombosaleapplied = Boolean(
                        response && response.data.isComboSaleApplied
                    );
                });
        }
        //#endregion

        //#endregion

        //#endregion
    },
]);
